/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S43_TitleInputs */

const es_tyc_obligations_s43_title = /** @type {(inputs: Tyc_Obligations_S43_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.3 Precision de los Datos`)
};

const en_tyc_obligations_s43_title = /** @type {(inputs: Tyc_Obligations_S43_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4.3 Data Accuracy`)
};

/**
* | output |
* | --- |
* | "4.3 Data Accuracy" |
*
* @param {Tyc_Obligations_S43_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s43_title = /** @type {((inputs?: Tyc_Obligations_S43_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S43_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s43_title(inputs)
	return en_tyc_obligations_s43_title(inputs)
});
export { tyc_obligations_s43_title as "tyc.obligations.s43_title" }